import React from 'react';
import styled from 'styled-components';
import MachineDisplayPart from './MachineDisplayPart';

const DropPanel = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  top: 100%;
  z-index: 20; 
  overflow: auto;  
`;

const DropInner = styled.div`
  padding: 0.75rem 1rem 1rem;
`;

const DetailTitle = styled.h2`
  margin: 0 0 0.25rem;
  font-size: 1.1rem;
`;

const DetailSub = styled.div`
  margin: 0 0 0.75rem;
  opacity: 0.75;
  font-size: 0.9rem;
`;

const PartsTreeRoot = styled.div`
  margin-top: 0.25rem;
  border-top: 1px solid rgba(255, 255, 255, 0.06);
  padding-top: 0.5rem;

  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem; /* space between cards */
`;

const EmptyState = styled.div`
  opacity: 0.6;
  font-size: 0.9rem;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
`;

// -----------------------------------------------------------------------------
// Part Tree structure
// -----------------------------------------------------------------------------


const PartContainer = styled.div`
  /* Make each card act as a tile in the flex row */
  flex: 0 0 19rem; /* don't grow, don't shrink, width = 19rem */
  margin: 0;       /* spacing now controlled by gap in PartsTreeRoot */

  display: flex;
  flex-direction: column;
`;

const PartArticle = styled.div`
  font-weight: 500;
`;

const PartDescription = styled.div`
  opacity: 0.8;
`;

const ChildrenContainer = styled.div`
  margin-left: 0.75rem;
  border-left: 1px dashed rgba(255, 255, 255, 0.12);
  padding-left: 0.5rem;
  margin-top: 0.15rem;
`;

function PartTree({ parts }) {
  if (!Array.isArray(parts) || parts.length === 0) return null;

  return (
    <>
      {parts.map((part, idx) => {
        const key = part.id || part.articleNumber || `part-${idx}`;
        return (
          <div key={key}>
            <PartContainer>
              <MachineDisplayPart part={part}/>
            </PartContainer>

            

            {// Part of Parts will need to be developed when that becomes a thing.
            Array.isArray(part.parts) && part.parts.length > 0 && (
              <ChildrenContainer>
                <PartTree parts={part.parts} />
              </ChildrenContainer>
            )}
          </div>
        );
      })}
    </>
  );
}

function MachineDisplayTree({activeAssembly}) {

activeAssembly && console.log("Active Assembly", activeAssembly)

  return (
          <DropPanel>
            <DropInner>
              <DetailTitle>{activeAssembly.articleNumber}</DetailTitle>
              <DetailSub>
                {activeAssembly.description}
                {activeAssembly.wNumber ? ` · ${activeAssembly.wNumber}` : ""}
              </DetailSub>

              {Array.isArray(activeAssembly.parts) &&
              activeAssembly.parts.length > 0 ? (
                <PartsTreeRoot>
                  <PartTree parts={activeAssembly.parts} />
                </PartsTreeRoot>
              ) : (
                <EmptyState style={{ height: "160px" }}>
                  No parts on this assembly
                </EmptyState>
              )}
            </DropInner>
          </DropPanel>
  );
}

export default MachineDisplayTree;